<template>
    <div class="txd__fields">
        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_customer') }}</span>
            <button v-if="canViewTransactions" type="button" class="txd__value customer-link"
                title="View all customer transactions" @click="$emit('view-customer-transactions', selectedTransaction.buyer_email.trim())">
                {{ selectedTransaction.rendered_buyer_fullname }}
            </button>
            <span v-else class="txd__value">{{ selectedTransaction.rendered_buyer_fullname }}</span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_transactions_email') }}</span>
            <div class="customer-email">
                <span class="txd__value">{{ selectedTransaction.rendered_buyer_email }}</span>
                <button v-if="hasValue(selectedTransaction.rendered_buyer_email)" type="button"
                    class="customer-copy" aria-label="Copy email address" title="Copy email address" @click="copyEmail">
                    <copy-icon aria-hidden="true" />
                </button>
                <span class="customer-copy-status" role="status">{{ copyStatus }}</span>
            </div>
        </div>

        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_transactions_phone') }}</span>
            <span v-if="hasValue(selectedTransaction.buyer_phone)" class="txd__value">{{ selectedTransaction.rendered_phone }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_transactions_company') }}</span>
            <span v-if="hasValue(selectedTransaction.buyer_company)" class="txd__value">{{ selectedTransaction.rendered_buyer_company }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>

        <div class="txd__field txd__field--wide">
            <span class="txd__label">{{ $t('frontend_analytics_transactions_address') }}</span>
            <span v-if="hasValue(selectedTransaction.buyer_address)" class="txd__value">{{ selectedTransaction.rendered_buyer_address }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>

        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_transactions_city') }}</span>
            <span v-if="hasValue(selectedTransaction.buyer_city)" class="txd__value">{{ selectedTransaction.buyer_city }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_transactions_state') }}</span>
            <span v-if="hasValue(selectedTransaction.buyer_state)" class="txd__value">{{ selectedTransaction.buyer_state }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>

        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_transactions_country') }}</span>
            <span v-if="hasValue(selectedTransaction.buyer_country)" class="txd__value">{{ selectedTransaction.buyer_country }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_transactions_zip') }}</span>
            <span v-if="hasValue(selectedTransaction.buyer_postal_code)" class="txd__value">{{ selectedTransaction.buyer_postal_code }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>

        <div class="txd__field txd__field--wide">
            <span class="txd__label">{{ $t('frontend_analytics_transactions_ip_address') }}</span>
            <span class="txd__value txd__value--mono">{{ selectedTransaction.buyer_ip }}</span>
        </div>
    </div>
</template>
<script>
import CopyIcon from '@/assets/images/icons/CopyIcon.svg';

export default {
    components: { CopyIcon },
    data() {
        return { copyStatus: '', copyTimer: null };
    },
    computed: {
        canViewTransactions() {
            return !this.$store.getters['internal/isDemoMode'] && this.hasValue(this.selectedTransaction.buyer_email);
        },
    },
    beforeDestroy() {
        clearTimeout(this.copyTimer);
    },
    props: {
        selectedTransaction: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async copyEmail() {
            const email = this.selectedTransaction.rendered_buyer_email;
            if (!this.hasValue(email)) return;
            let fallback;
            try {
                try {
                    await navigator.clipboard.writeText(email);
                } catch (error) {
                    fallback = document.createElement('textarea');
                    fallback.value = email;
                    fallback.style.position = 'fixed';
                    fallback.style.opacity = '0';
                    this.$el.appendChild(fallback);
                    fallback.select();
                    if (!document.execCommand('copy')) throw new Error('Copy failed');
                }
                this.copyStatus = 'Copied';
            } catch (error) {
                this.copyStatus = 'Unable to copy. Please select the email.';
            } finally {
                if (fallback) fallback.remove();
            }
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => { this.copyStatus = ''; }, 2500);
        },
        hasValue(value) {
            return !!value && String(value).trim() != '';
        },
    },
}
</script>

<style scoped>
.customer-link { border: 0; background: none; padding: 0; text-align: left; color: #ff007a; cursor: pointer; text-decoration: underline; text-underline-offset: 3px; }
.customer-email { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.customer-email .txd__value { overflow-wrap: anywhere; min-width: 0; }
.customer-copy { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; width: 28px; height: 28px; padding: 5px; border: 0; border-radius: 4px; background: none; color: #65728c; cursor: pointer; }
.customer-copy:hover { background: #f4f5f8; color: #ff007a; }
.customer-copy svg { width: 16px; height: 16px; }
.customer-copy-status { font-size: 12px; color: #65728c; }
.customer-link:focus-visible, .customer-copy:focus-visible { outline: 2px solid #ff007a; outline-offset: 3px; }
</style>
